module.exports = __webpack_public_path__ + "img/c04.23e490b0.png";